import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fileSrc } from "@/lib/api";
import { toast } from "sonner";
import { Download, Trash2, Film } from "lucide-react";

const FMT = { square: "Carré", portrait: "Portrait", landscape: "Facebook", story: "Story" };

export default function MontagesGallery() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/montages").then((r) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!rows.length) return null;
  const del = async (id) => { try { await api.delete(`/montages/${id}`); load(); toast.success("Montage supprimé"); } catch { toast.error("Suppression impossible"); } };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 mb-5" data-testid="montages-gallery">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-800 mb-3"><Film className="w-4 h-4 text-emerald-600" /> Montages avant / après enregistrés ({rows.length})</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
        {rows.map((m) => (
          <div key={m.id} className="space-y-1" data-testid={`gallery-montage-${m.id}`}>
            <a href={fileSrc(m.url)} target="_blank" rel="noreferrer"><img src={fileSrc(m.url)} alt="" className="w-full aspect-square object-cover rounded-lg border border-slate-200" /></a>
            <div className="text-[11px] text-slate-600 truncate">{m.client_name || "—"} · {FMT[m.format] || m.format}</div>
            <div className="flex items-center gap-2 text-[11px]">
              {!m.consent && <span className="text-amber-700">Sans autorisation</span>}
              <button onClick={() => navigate(`/rdv/${m.appointment_id}/atelier?tab=photos`)} className="text-emerald-700 underline">RDV</button>
              <a href={fileSrc(m.url)} download className="text-slate-500"><Download className="w-3.5 h-3.5" /></a>
              <button onClick={() => del(m.id)} className="text-red-500 ml-auto"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
